module.exports = __webpack_public_path__ + "static/media/tinla_S22.85498798.pdf";